import React from "react";
import { EmptyState } from "components/shared/EmptyState";
import { zeroData } from "utils/emptyCopy";

interface DealersEmptyStateProps {
  isLoading: boolean;
  onAddDealer: () => void;
  message?: string;
  addButtonText?: string;
}

const DealersEmptyState: React.FC<DealersEmptyStateProps> = ({
  isLoading,
  onAddDealer,
  message = `${zeroData("dealers")} Try adjusting your search criteria or add a new dealer.`,
  addButtonText = "+ Add Dealer",
}) => {
  if (isLoading) return null;

  return (
    <EmptyState
      message={message}
      actionLabel={addButtonText}
      onAction={onAddDealer}
    />
  );
};

export default DealersEmptyState;
